import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from '../../config/features/config';
import { BreakpointsState } from '../../state/breakpointsState/BreakpointsState';
import { StarRouter } from '../../state/router/StarRouter';
import { useOptimoveHost } from './useOptimoveHost';

export const OptimoveHost = observer('OptimoveHost', () => {
    const common = useCommon();
    const { optimoveBadgeHostId, intercomChat, freshDeskChat } = ConfigComponents.get(common).config;
    const isDesktop = BreakpointsState.get(common).desktop.isBiggerOrEq === true;
    const isCasino = StarRouter.get(common).currentView?.name === 'casino';

    useOptimoveHost(optimoveBadgeHostId, isDesktop, isCasino, intercomChat === true, freshDeskChat !== null);

    return null;
});
